import { Button, Col, Row, Form, Select, theme, Collapse, Tabs } from "antd";
import _ from "lodash";
import moment from "moment";
import React, { useState, useCallback, useEffect } from "react";
import {
  getListDepartments,
  getYearlyPlanList,
  getYearlProjectListYEAR,
} from "../../../../services/progressPerformance";
import useKpiTabs from "../../../../lib/hooks/useKpiTabs";
import { SUCCESS_CODE } from "../../../../lib/const";
import IndicatorTab from "./indicatorTab";
import ProjectTab from "./projectTab";
import YearlyTab from "./yearlyTab";

const { Option } = Select;
const { Panel } = Collapse;

const { useToken } = theme;

const Content = ({ roleUser }) => {
  const { token } = useToken();
  const { tabs, setTabs } = useKpiTabs();
  const [form] = Form.useForm();

  const panelStyle = {
    marginBottom: 0,
    borderRadius: "16px",
    border: "none",
  };

  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [yearlyPlan, setYearlyPlan] = useState([]);
  const [listAllYear, setListAllYear] = useState([]);
  const [yearArray, setYearArray] = useState([]);

  const convertDataList = async (dataList) => {
    const result = dataList.reduce((acc, item) => {
      const {
        yearOfBudget,
        projectId,
        projectNameEn,
        projectNameTh,
        indicatorId,
        indicatorNameEn,
        indicatorNameTh,
        departmentId,
        // id,
      } = item;
      const yearIndex = acc.findIndex((x) => x.yearOfBudget === yearOfBudget);
      if (yearIndex === -1) {
        let object = {
          yearOfBudget,
          indicators: [
            {
              // id,
              indicatorId,
              indicatorNameEn,
              indicatorNameTh,
              projects: [
                {
                  projectId,
                  projectNameEn,
                  projectNameTh,
                  departmentId,
                },
              ],
            },
          ],
        };

        // form.setFieldsValue(object);
        acc.push(object);
      } else {
        const indicatorIndex = acc[yearIndex].indicators.findIndex(
          (x) => x.indicatorId === indicatorId
        );
        if (indicatorIndex === -1) {
          let object = {
            // id,
            indicatorId,
            indicatorNameEn,
            indicatorNameTh,
            projects: [
              {
                projectId,
                projectNameEn,
                projectNameTh,
                departmentId,
              },
            ],
          };
          // form.setFieldsValue(object);
          acc[yearIndex].indicators.push(object);
        } else {
          let object = {
            projectId,
            projectNameEn,
            projectNameTh,
            departmentId,
          };
          acc[yearIndex].indicators[indicatorIndex].projects.push(object);
        }
      }
      return acc;
    }, []);

    return result;
  };

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  const fetchListYearlyPlan = useCallback(async () => {
    try {
      const res = await getYearlyPlanList();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = await convertDataList(res.data.objectValue);

        const mapData = result_data.map((value) => {
          const mapIndicators = value.indicators.map((ind) => {
            form.setFieldsValue({
              indicatorId: ind.indicatorId,
              indicatorNameEn: ind.indicatorNameEn,
              indicatorNameTh: ind.indicatorNameTh,
              projects: ind.projects,
            });

            return Object.assign(ind, { form: form });
          });

          form.setFieldsValue({
            indicators: mapIndicators,
            yearOfBudget: value.yearOfBudget,
          });

          return {
            ...value,
            form,
          };
        });

        setYearlyPlan(mapData);
      }
    } catch (error) {}
  }, [yearlyPlan]);

  const fetchListAllYear = useCallback(async () => {
    try {
      // call ListAllYear api
      const res = await getYearlProjectListYEAR();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;

        const yearArr = Array.from({ length: 10 }, (v, i, k) =>
          String(moment().year() + i + 543)
        );
        const filtered = yearArr.filter((item) => !result_data.includes(item));
        setYearArray(filtered);
        setListAllYear(result_data);
      }
    } catch (error) {}
  }, [listAllYear]);

  useEffect(() => {
    fetchListAllYear();
  }, []);

  useEffect(() => {
    fetchListYearlyPlan();
  }, []);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  const [year, setYear] = useState(null);

  const items = (value) => {
    return [
      {
        key: "project",
        label: <strong>กำหนดโครงการ</strong>,
        children: <ProjectTab year={value} />,
      },
      {
        key: "indicator",
        label: <strong>กำหนดแผนยุทธศาสตร์</strong>,
        children: <IndicatorTab year={value} />,
      },
      {
        key: "yearly",
        label: <strong>สรุปแผนยุทธศาสตร์ทั้งหมด</strong>,
        children: <YearlyTab year={value} />,
      },
    ];
  };

  const onCreateKpi = () => {
    if (year) {
      const filtered = yearArray.filter((item) => item !== String(year));

      setYear(null);
      setYearArray(filtered);
      setListAllYear([...listAllYear, year]);
      setYearlyPlan([...yearlyPlan, { yearOfBudget: year }]);
    }
  };

  return (
    <div>
      <Row
        gutter={[24, 24]}
        style={{ marginTop: 15, justifyContent: "center" }}
      >
        <Col span={24}>
          <Row
            gutter={[8, 0]}
            className="card"
            style={{
              marginBottom: "24px",
              alignItems: "center",
            }}
          >
            <Col span={12}>
              {/* <Form.Item name={"yearOfBudget"}> */}
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="ปีงบประมาณ"
                value={year}
                onChange={(event) => {
                  setYear(event);
                }}
              >
                {yearArray.map((item) => (
                  <Option value={parseInt(item)}>{parseInt(item)}</Option>
                ))}
              </Select>
              {/* </Form.Item> */}
            </Col>
            <Col span={3}>
              <Button
                style={{ width: "100%" }}
                type="primary"
                onClick={() => onCreateKpi()}
                disabled={_.isNull(year)}
              >
                สร้าง
              </Button>
            </Col>
          </Row>

          {listAllYear &&
            listAllYear.map((el, k) => (
              <Row gutter={[8]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={["0"]}
                    expandIconPosition={"end"}
                    style={{
                      background: token.colorBgContainer,
                    }}
                  >
                    <Panel
                      header={
                        <>
                          <span className="box-border"></span>ปีงบประมาณ&nbsp;
                          {moment(`${Number(`${el}`)}`).year()}
                        </>
                      }
                      key="1"
                      style={panelStyle}
                    >
                      <Tabs
                        activeKey={tabs}
                        items={items(el)}
                        onChange={() => {}}
                      />
                    </Panel>
                  </Collapse>
                </Col>
              </Row>
            ))}
        </Col>
      </Row>
    </div>
  );
};

export default Content;
